import { createStringLiteral } from 'modules/handlebars/domain/literal/utils';
import { parseDateParameter } from './parseDateParameter';
import { splitRelativeDateString } from './splitRelativeDateString';

export const parseRelativeDateString = (relativeDateStr: string) => {
  const [dateParameterStr, relativeDateEquationStr] = splitRelativeDateString(relativeDateStr);
  const dateParameter = parseDateParameter(dateParameterStr);
  const relativeDateEquation = createStringLiteral(relativeDateEquationStr);
  return { dateParameter, relativeDateEquation };
};
